// libs
import { useDispatch } from 'react-redux'
//store
import { addRisk } from 'store/reducers/offlineRisk'
// hooks
import { useOfflineQueue } from 'hooks/offline/useOfflineQueue'
// utils
import { generateTempId } from 'utils/helpers'

export const useOfflineRiskCreate = () => {
  const dispatch = useDispatch()

  const { addMutation } = useOfflineQueue()

  const offlineRiskCreate = (riskTemplateId: string) => {
    const tempId = generateTempId()

    addMutation({
      type: 'riskCreate',
      variables: {
        input: {
          riskTemplateId
        }
      },
      tempId
    })

    dispatch(addRisk({ riskId: tempId, templateId: riskTemplateId, createdAt: new Date().getTime() }))

    return tempId
  }

  return offlineRiskCreate
}
